/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 16:20:41
 * @LastEditors: K
 * @LastEditTime: 2022-08-04 17:47:13
 */
import { TableColumnType } from 'antd';
import React from 'react';

export const Columns = (
  onClick: (t: any) => void,
  startIndex: number,
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // render: function tenantCategory(_, t) {
    //   return (
    //     <a onClick={() => onClick(t)}>查看详情 </a>
    //   )
    // },
    {
      title: '订单号',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
    },
    {
      title: '产品类型',
      key: 'productName',
      dataIndex: 'productName',
      align: 'center',
    },
    {
      title: '时长/次数',
      dataIndex: 'durationNumStr',
      key: 'durationNumStr',
      align: 'center',
    },
    {
      title: '单价',
      dataIndex: 'price',
      key: 'price',
      align: 'center',
      render: function tenantCategory(_, t) {
        return t.price.toFixed(2)
      },
    },
    {
      title: '折扣',
      dataIndex: 'discountNum',
      key: 'discountNum',
      align: 'center',
    },
    {
      title: '实收金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      render: function tenantCategory(_, t) {
        return t.amount.toFixed(2)
      },
    },
    {
      title: '支付类型',
      dataIndex: 'productName',
      key: 'productName',
      align: 'center',
    },
    {
      title: '起始时间',
      dataIndex: 'serveStartTime',
      key: 'serveStartTime',
      align: 'center',
    },
    {
      title: '终止时间',
      dataIndex: 'serveEndTime',
      key: 'serveEndTime',
      align: 'center',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
    },
  ]
}

